import React from "react";
import { FormControlLabel, Grid, Switch, TextField } from "@mui/material";
import { AutocompleteComponent } from "components/Autocomplete/AutocompleteComponent";

export const PolicyMovForm = ({
  values,
  original,
  onChange,
  onChangeNumber,
  setValues,
  errors,
  accounts,
  edit = false,
  byPayment = false,
  setByPayment,
}) => {
  return (
    <>
      <Grid item xs={12} sm={12}>
        {edit ? (
          <TextField
            label="Cuentas"
            variant="outlined"
            fullWidth
            name="name"
            value={original.name}
          />
        ) : (
          <AutocompleteComponent
            label="Cuentas"
            variant="outlined"
            fullWidth
            name="account"
            value={values.account}
            handleValues={setValues}
            options={accounts}
            textFieldProps={{
              error: errors.account,
              helperText: errors.account,
            }}
          />
        )}
      </Grid>
      <Grid
        item
        xs={12}
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <FormControlLabel
          control={
            <Switch
              checked={byPayment}
              onChange={setByPayment}
              name="byPayment"
              color="primary"
            />
          }
          label={byPayment ? "Agregar Cargo" : "Agregar Abono"}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <TextField
          label="Cargo"
          variant="outlined"
          fullWidth
          name="charge"
          value={edit ? original.charge : values.charge_}
          onChange={onChangeNumber}
          error={edit ? false : errors.charge}
          helperText={edit ? false : errors.charge}
          disabled={edit || byPayment}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <TextField
          label="Abono"
          variant="outlined"
          fullWidth
          name="payment"
          value={edit ? original.payment : values.payment_}
          onChange={onChangeNumber}
          error={edit ? false : errors.payment}
          helperText={edit ? false : errors.payment}
          disabled={edit || !byPayment}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Concepto"
          variant="outlined"
          fullWidth
          multiline
          rows={4}
          name="concept"
          value={values.concept}
          onChange={onChange}
        />
      </Grid>
    </>
  );
};
